export default "__VITE_ASSET__B1XAzf_a__"